// extracted by mini-css-extract-plugin
export default {"p":"styles_p__x6xdY","h":"styles_h__cpZ4x"};